angular.module('app').factory('skinService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/skin/");

        return {
            getAllSkins: function (requestData) {
                if (!requestData) {
                    requestData = {status: 'published'};
                }
                return restAngular.
                    one("getList").
                    customGET(param(requestData))
            },
            getAllSkinsList: function (requestData) {
                return restAngular.
                one("get").
                customGET(param(requestData))
            },
            editSkin: function (requestData) {
                return restAngular.
                    one("change").
                    post("", requestData)
            },
            getSkinById: function (requestData) {
                return restAngular.
                    one("get").
                    customGET(param(requestData))
            },
            deleteSkin: function (requestData) {
                return restAngular.
                    one("delete").
                    customGET(param(requestData))
            },
            retest: function (requestData) {
                return restAngular.
                    one("reset").
                    post("", requestData)
            },
            generate: function (requestData) {
                return restAngular.
                    withHttpConfig({timeout: 3600}).
                    one("generateSiteMap").
                    customGET(param(requestData))
            },
            getSkinsByProvider: function (requestData) {
                return restAngular.
                one("getSkinsByProvider").
                customGET(param(requestData))
            },
            getSkinsByGame: function (requestData) {
                return restAngular.
                one("getSkinsByGame").
                customGET(param(requestData))
            },
            buildMobile: function (requestData) {
                return restAngular.
                    one("buildMobile").
                    post("", requestData);

            },
            getAllProducts: function (){
                return restAngular.
                one("getAllProducts").
                get()
            }
        }
    }
]);
